#import "../fragments/app-message-fragment.graphql"

query GetAppMessages {
    appMessages {
        ...AppMessageFragment
    }
}
